import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function PrivacyPolicy() {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const renderContent = (text) => {
        return text.split('\n').map((line, index) => {
            const trimmedLine = line.trim();
            if (trimmedLine === 'Data Privacy' || trimmedLine === 'Confidentialité des Données') {
                return <h3 key={index} className='text-xl sm:text-2xl font-bold text-deepblue mt-8 mb-3'>{trimmedLine}</h3>;
            } else if (trimmedLine === '') {
                return null;
            } else {
                return <p key={index} className='mb-4 text-base text-gray-700 leading-relaxed text-justify'>{trimmedLine}</p>;
            }
        });
    };

    return (
        <div className='items-center w-full p-0 flex flex-col min-h-screen'>
            <img className='fixed top-0 left-0 w-full -z-50' src='img/ny.png' alt='background' />
            <div className='mt-[150px] w-full max-w-4xl mx-auto px-6 py-10 mb-40 bg-white/90 rounded-lg shadow-lg'>
                <h1 className='text-3xl sm:text-4xl font-bold mb-8 text-deepblue text-center uppercase tracking-wider'>{t('privacyPolicy.title')}</h1>
                <div>
                    {renderContent(t('privacyPolicy.content'))}
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
